import { render, staticRenderFns } from "./promoSignupTab.vue?vue&type=template&id=92218344&lang=pug"
import script from "./promoSignupTab.vue?vue&type=script&lang=js"
export * from "./promoSignupTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports